<template>
  <custom-link :label="label" :to="to" />
</template>

<script>
import CustomLink from "@/components/core/CustomLink";

export default {
  name: "ContactLink",
  components: { CustomLink },
  props: {
    label: {
      type: String,
      default: "Quiero que me contacten"
    }
  },
  computed: {
    to() {
      return this.$route.path + "/contacto";
    }
  }
};
</script>

<style scoped>
p a {
  font-family: BentonSansBBVA-Medium, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.6;
  letter-spacing: normal;
  text-align: left;
  color: #1973b8;
  text-decoration: none;
  cursor: pointer;
}
.inline {
  display: inline;
}
</style>
